<template>
  <th>
    <v-snackbar color="error" top v-model="popup" :timeout="timeout">
      {{ popupText }}

      <!-- <template v-slot:action="{ attrs }">
        <v-btn
          class="warning"
          color="blue"
          text
          v-bind="attrs"
          @click="popup = false"
        >
        </v-btn>
      </template> -->
    </v-snackbar>
    <v-text-field
      label=""
      dense
      type="number"
      style="max-width: 60px; font-size: 11px"
      @change="changed"
      @leave="changed"
      v-model="targetTime"
    >
    </v-text-field>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    entity: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      targetTime: "",
      popup: false,
      popupText: "",
      timeout: 3000,
    };
  },
  methods: {
    ...mapActions(["deleteFilterKey", "setFilterKey", "getSettings"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      // console.log("Changed:" + this.targetTime);
      let key = this.entity + this.name;
      let key_to_delete = this.entity + this.name;
      let value = this.targetTime;
      if (!this.targetTime) {
        this.deleteFilterKey({ key_to_delete });
        this.$emit("filter_update");
        return;
      } else if (this.targetTime <= 0) {
        this.popup = true;
        this.popupText = "Время должно быть положительным";
        // console.log("Время должно быть положительны:" + this.targetTime);
        this.targetTime = "";
        return;
      } else {
        this.setFilterKey({ key, value });
      }
      this.$emit("filter_update");
    },

    findValueByPrefix: function (object, prefix) {
      for (var property in object) {
        if (
          Object.prototype.hasOwnProperty.call(object, property) &&
          property.toString().startsWith(prefix)
        ) {
          return [property, object[property]];
        }
      }
    },
  },

  created() {
    // console.log("Entity + name = " + this.entity + this.name);
    let prefix = this.entity + this.name;
    let settings = this.getSettings().filters;
    let result = this.findValueByPrefix(settings, prefix);
    if (!result) {
      return;
    }
    // let key = result[0];
    let value = result[1];
    // console.log("KEY: " + key + " VALUE: " + value);
    this.targetTime = value;
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0 !important;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield !important;
}
</style>
